import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

export const SMOKING_STATUS_OPTIONS = [
  { value: 'never', label: 'Never' },
  { value: 'former', label: 'Former' },
  { value: 'current', label: 'Current' },
] as const;

export const SEX_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
] as const;

export const addPartnerSchema = z.object({
  firstName: z.string().trim().optional(),
  lastName: z.string().trim().optional(),
  birthDate: z.date({ required_error: 'Birth date is required' }),
  sex: z.enum(['male', 'female'], {
    required_error: 'Please select a sex',
  }),
  smokingStatus: z.enum(['never', 'former', 'current'], {
    required_error: 'Please select smoking status',
  }),
  zipCode: z
    .string()
    .min(1, 'Zip code is required')
    .regex(/^\d{5}$/, 'Must be a 5-digit zip code'),
  email: z.string().email('Invalid email address'),
  sendInviteNow: z.boolean().default(false),
});

export type AddPartnerFormValues = z.infer<typeof addPartnerSchema>;

interface UseAddPartnerFormOptions {
  onSubmit: (data: AddPartnerFormValues) => void;
}

export function useAddPartnerForm({ onSubmit }: UseAddPartnerFormOptions) {
  const form = useForm<AddPartnerFormValues>({
    resolver: zodResolver(addPartnerSchema),
    mode: 'onChange',
    defaultValues: {
      firstName: '',
      lastName: '',
      zipCode: '',
      email: '',
      sendInviteNow: false,
    },
  });

  return {
    form,
    onSubmit: form.handleSubmit(onSubmit),
    isValid: form.formState.isValid,
  };
}
